import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetGstHsnCodeListQuery,
  useGetGsthsncodeCountQuery
} from "../../../../store/api/gsthsn";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import SearchFilters from "../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import PopBox from "../../../../Components/Popup/Popup";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling,pageSize } = useScreenHeight();

  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [isPopBoxOpen, setIsPopBoxOpen] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showFilters, setShowFilters] = useState(false)

  const siNoFilter = filters.siNo?.trim();
  const isSiNoActive = siNoFilter !== undefined && siNoFilter !== "";

//states used for deleting the record
  const [deleteDoc] = useDeleteDocMutation();
  const [delPopupVisible, setDelPopupVisible] = useState(false);
  const [delSelectedId, setDelSelectedId] = useState(null);
  const [delmessage, setDelmessage] = useState();
  const [alreadySubmitData, setAlreadySubmitData] = useState(false);
  const [delDone, setDelDone] = useState(false);
  const targetPage = isSiNoActive
    ? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
    : currentPage;

  const buildFilterArray = (filtersObj) => {
    return Object.entries(filtersObj)
      .filter(([key, value]) => key !== "siNo" && value && value.trim() !== "")
      .map(([key, value]) => {
        if (key === "creation") {
          return ["GST HSN Code", key, "like", `${value}%`];
        }
        if (key === "name" || key === "hsn_code" || key === 'description') {
          return ["GST HSN Code", key, "like", `%${value}%`];
        }
        return ["GST HSN Code", key, "=", value];
      });
  };

  const {
    data: apiData,
    isLoading,
    refetch:refetchGsnCode
  } = useGetGstHsnCodeListQuery({
    start: (targetPage - 1) * pageSize,
    limit: pageSize,
    filters: buildFilterArray(filters)
  });

  const { data: totalCount , refetch: refetchGsnCodeCount} = useGetGsthsncodeCountQuery();

  useEffect(() => {
    if (totalCount) {
      setTotalRecords(totalCount.message);
    }
  }, [totalCount]);

  useEffect(() => {
    if (apiData) {
      const rawData = apiData.data || [];
      const numberedData = rawData.map((item, idx) => ({
        ...item,
        siNo: idx + 1 + pageSize * (targetPage - 1)
      }));

      const finalData = isSiNoActive
        ? numberedData.filter(item => item.siNo === parseInt(siNoFilter, 10))
        : numberedData;

      setData(finalData);

      if (isSiNoActive && currentPage !== targetPage) {
        setCurrentPage(targetPage);
      }
    }
  }, [apiData, isSiNoActive, siNoFilter, targetPage, currentPage, pageSize,screenHeight, screenScaling]);

  useEffect(() => {
    if(pageSize > 0)
      refetchGsnCode();
  }, [filters, currentPage, refetchGsnCode, pageSize,screenHeight, screenScaling]);

  // Filters config for SearchFilters component
  const filtersConfig = [
    { name: "siNo", label: "S. No.", width: "8%", type: 'text' },
    { name: "hsn_code", label: "HSN Code", width: "26%", type: 'text' },
    { name: "description", label: "Description", width: "26%", type: 'text' },
    { name: "creation", label: "Date", type: "date", width: "26%" }
  ];

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleView = (id) => {
    navigate(`/master/gsthsncode/gst-hsn-view/`, { state: { taxId: id } });
  };

  const handleEdit = (id) => {
    navigate(`/master/gsthsncode/gst-hsn-edit/`, { state: { taxId: id } });
  };


  const handleDelete = (id) => {
    setDelSelectedId(id);
    setDelPopupVisible(true);
    setAlreadySubmitData(false);
    setDelmessage("Are you sure you want to Delete this GST HSN Code?");
  };

  const delHandleCancel = () => {
    setDelPopupVisible(false);
    setDelSelectedId(null);
  };

  const delHandleConfirm = async () => {
    try {
      await deleteDoc({
        doctype: "GST HSN Code",
        name: delSelectedId,
      }).unwrap();
      setDelmessage(`GST HSN Code ${delSelectedId} deleted successfully!`);
      setDelDone(true);
      setTimeout(() => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
        setDelDone(false);
        refetchGsnCodeCount();
        refetchGsnCode();
      }, 1000);
    } catch (err) {
      console.error("Deletion Failed:", err);

      let errorMessage = "Failed to delete the GST HSN Code!";

      //If the server is sending the error message , we will extract it.
      if (err?.data?._server_messages) {
        try {
          const messageArr = JSON.parse(err.data._server_messages);
          if (messageArr && messageArr.length > 0) {
            //parse inner json object
            const messageObj = JSON.parse(messageArr[0]);
            if (messageObj?.message) {
              //extract the exact message we want
              const fullMessage = messageObj.message;
              errorMessage = fullMessage.split("You must")[0].trim();
              //remove html in the message
              errorMessage = errorMessage.replace(/<[^>]+>/g, "");
            }
          }
        } catch (parseError) {
          console.error("Error parsing server messages:", parseError);
        }
      }
      setDelPopupVisible(true);
      setDelmessage(errorMessage);
      setAlreadySubmitData(true);
    } finally {
      // setTimeout(() => {
      //     setDelPopupVisible(false);
      //     setDelSelectedId(null);
      // }, 2000);
    }
  };

  const [columnsConfig, setColumnsConfig] = useState(() => [

    {
      header: "S. No.",
      name: "S. No.",
      accessor: "siNo",
      visible: true,
      sortable: false,
      width: "7%",
      cellRenderer: (row) => row.siNo,
    },
    {
      header: "HSN Code",
      name: "HSN Code",
      accessor: "hsn_code",
      visible: true,
      sortable: true,
      width: "26%"
    },
    {
      header: "Description",
      name: "Description",
      accessor: "description",
      visible: true,
      sortable: true,
      width: "26%",
      cellRenderer: (row) => {
    const desc = row.description || "";
    const limit = 80; // ✅ you can adjust this limit (e.g., 50, 100, etc.)
    return desc.length > limit ? desc.substring(0, limit) + "..." : desc;
  }
    },
    {
      header: "Date",
      name: "Date",
      accessor: "creation",
      visible: true,
      sortable: true,
      cellRenderer: (row) => row.creation?.split(" ")[0],
      width: "26%"
    },
    {
      header: "Action",
      name: "Action",
      accessor:"action",
      visible: true,
      width: "0%",
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.name}
          onView={() => handleView(row.name)}
          onEdit={() => handleEdit(row.name)}
          onDelete={() => handleDelete(row.name)}
        />
      )
    }
  ]
  );
  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  };

  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);

  const actionButtons = [
    {
      className: "createbtnsfilter border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtnshowmore border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtnexport border-0 d-flex",
      style: { gap: "2px", height: "28px",backgroundColor : '#E6A744' },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/gsthsncode/gst-hsn-create",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add GST HSN Code"
    }
  ];
  const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
		.map((column) => column.accessor);
  return (
    <div className="container-fluid d-flex flex-column" style={{ flexGrow: "1" }}>
      <Tabs />
      <ListLayout
        breadcrumbItems={[
          { label: "GST HSN Code" },
          { label: "GST HSN Code List", style: { color: "#4b002b" } }
        ]}
        actionButtons={actionButtons}
      >
        {
          showFilters && <ListFilters
            filtersConfig={filtersConfig}
            onFilterChange={handleFilterChange}
            currentFilters={filters}
            setShowFilters={setShowFilters}
          />
        }
        {showColumnConfig &&
          <ConfigureColumnsNew
            show={showColumnConfig}
            onClose={() => setShowColumnConfig(false)}
            onSave={handleSaveColumns}
            docType="GST HSN Code"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map(col => ({
              fieldname: col.accessor,
              label: col.name
            }))}
            disabledFields={["siNo", "hsn_code", "action", "creation"]}
          />}

        <Table columns={visibleColumns} data={data} loading={isLoading} />
        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          totalRecords={totalRecords}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />
        {delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
        )}
        
        {showExportPopup && (
          <ExportCSV
            doctype="GST HSN Code"
            fieldsData={accessors}
            onClose={() => setShowExportPopup(false)}
          />
        )}
        <PopBox
          isOpen={isPopBoxOpen}
          onClose={() => setIsPopBoxOpen(false)}
          title="Select Company"
        >
          <div className="selectbox">
            <p>Settings content goes here</p>
          </div>
        </PopBox>
      </ListLayout>

    </div>
  );
};

export default MainContent;
